export enum JOB_OPENING_TYPE {
  JOB_OPENING_DETAILS = 'Job Opening Details',
  JOB_POSTING = 'Job Posting',
  APPLICANT_ANALYSIS = 'Applicant Analysis',
  AUTO_SUITABILITY = 'Auto-Suitability',
  AUTO_OUTSTANDING = 'Auto-Outstanding',
  AUTO_ASSESMENTS = 'Auto-Assessments',
  SMART_INTERVIEWS = 'Smart Interviews',
  PSYCHOMETRIC = 'Psychometric',
  WELLNESS = 'Wellness',
  ANALITICS = 'Analytics',
  CCA = 'CCA',
}
